import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { IFieldArray } from "AngularFormly";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../../../../records/forms/formView";
import { MachineGateway } from "../../../../../models/machine";
import { MachineConfigurationGateway } from "../../../../../models/machineConfiguration";
import {
  MachineConfigurationProgressiveInformation,
  ProgressiveDefinitionView,
} from "../../../../../models/progressiveDefinition";
import { vsTypeName as ProgressiveDefinitionSelectTypeName } from "./progressiveDefinitionSelect/typeDefinition";

export class MachineDetailProgressiveConfigurationEditComponentController
  implements IOnInit
{
  static $inject = [FormViewServiceName, "$state"];

  private formFields: IFieldArray = [];
  private model: {
    ProgressiveDefinitionId?: number;
  } = {};

  /*bindings*/
  machine!: MachineGateway;
  machineConfiguration!: MachineConfigurationGateway;
  machineConfigurationProgressiveInformation!: MachineConfigurationProgressiveInformation;
  /* end bindings */

  selectedProgressiveDefinition!: ProgressiveDefinitionView;
  progressiveDefinitionQueryResults: ProgressiveDefinitionView[] | undefined;

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService
  ) {}

  $onInit(): void {
    this.model = {
      ProgressiveDefinitionId:
        this.machineConfigurationProgressiveInformation.ProgressiveDefinition
          ?.Id,
    };
    this.formFields = [
      {
        type: ProgressiveDefinitionSelectTypeName,
        id: "ProgressiveDefinitionId",
        name: "ProgressiveDefinitionId",
        key: "ProgressiveDefinitionId",
        templateOptions: {
          showProgressiveInfo: true,
          label: "Progressive",
        },
        data: {
          machine: this.machine,
          machineConfiguration: this.machineConfiguration,
          machineConfigurationProgressiveInformation:
            this.machineConfigurationProgressiveInformation,
          initialProgressiveDefinition:
            this.machineConfigurationProgressiveInformation
              .ProgressiveDefinition,
        },
      },
    ];
  }

  submit(formViewController: FormViewController) {
    const url = `/api/machines/MachineConfiguration/${this.machineConfiguration.Id}/ProgressiveDefinitionId`;
    return this.formViewService
      .submitForm<MachineConfigurationGateway>({
        method: "put",
        formObject: this.model,
        formViewController,
        url,
      })
      .then(() => {
        this.$state.go("^", undefined, { reload: true });
      });
  }

  cancel() {
    return this.$state.go("^");
  }
}
